import React, {useEffect, useState} from "react";
import {
    Col,
    Container,
    Row
  } from 'react-bootstrap';
import {LoaderMedium} from './../../components/loader';
import {alertResponseMessage} from './../../actions/action-creators/response';
import {post_api_call} from '../../actions/action-creators/common';

function AffiliateVerification() {
    const [isLoader, setIsLoader] = useState(true);
    useEffect(()=>{
        _verification();
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    const _verification = async() => {
        try{
            const query = new URLSearchParams(window.location.search);
            const refId = query.get("ref_id") || "";
            const tmpId = query.get("tmp_id") || "";
            if(refId && tmpId){
                const apiData = await post_api_call('affiliate/verification', {ref_id: refId, tmp_id: parseInt(tmpId)});
                if(apiData.status === 200){
                    setIsLoader(false);
                    alertResponseMessage({alert_type: 1, message: "Email Verified Successfully"});
                }else{
                    alertResponseMessage({alert_type: 2, message: apiData.message});
                }
            }else{
                alertResponseMessage({alert_type: 2, message: "Error verifying! Link tampered."});
            }
        }catch(e){
            alertResponseMessage({alert_type: 2, message: "Error verifying! Please try after some times."});
        }
    }

    return (
        <div className="c-app c-default-layout align-items-center custom-form">
            <Container style={{minHeight: '66vh'}}>
                <Row className="justify-content-center">
                    <Col md="6">
                        <div className="p-2 text-center mb-3">
                            {isLoader
                            ?
                                <LoaderMedium size={65} />
                            :
                                <div className="alert alert-success text-center mb-0" role="alert">
                                    <strong className="fs-1">Thank You!</strong>
                                    <p className="mt-2 fs-5">Email Verified Successfully! Thank you for applying to the PORT Affiliate Program. Our team will review your application and share your affiliate dashboard access shortly.</p>
                                </div>
                            }
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default AffiliateVerification;